import intl from 'react-intl-universal'

class RequestError {
    constructor(error) {
        this.error = error;
        if (error.message)
            this.message = error.message
        else 
            this.message = intl.get("err.request")
    }
}
RequestError.prototype.toString = function () {
    return this.error;
}
export default RequestError;